export default __webpack_public_path__ + "static/media/clouds.57a70ad8.png";